module.exports = __webpack_public_path__ + "img/slide-18-2.6b5e1ae4.jpg";